import React from 'react'
import { makeStyles, createStyles } from '@material-ui/core/styles'

import type { ITheme } from '@homeviews/styles'
import { WindowTitle } from '@homeviews/shared-ui'

const useStyles = makeStyles((theme: ITheme) =>
  createStyles({
    root: {
      padding: theme.spacing(
        theme.layout.contentHorizontalPadding,
        theme.layout.contentVerticalPadding,
      ),
    },
  }),
)

const SingleFaq: React.FC = () => {
  const classes = useStyles()
  return (
    <>
      <WindowTitle title="Faq Item" />
      <div className={classes.root} />
    </>
  )
}

export default SingleFaq
